import React from "react";

import { ConfirmationContainer, ConfirmationIcon } from "./styles";
import { SignInButton } from "~/pages/Auth/SingIn/styles";
import login from "~/assets/images/login.svg";
import { useDispatch } from "react-redux";

function Uac(props) {
  const dispatch = useDispatch();

  return (
    <ConfirmationContainer>
      <ConfirmationIcon className="fa fa-times-circle-o" />
      <div className="w-100 text-center mt-4">
        <p style={{ fontSize: 17 }}>
          Ops! Precisaremos atualizar o seu cadastro.
        </p>
        <p
          style={{
            fontSize: 14,
            color: "#4D565C",
            marginBottom: 10,
          }}
        >
          Entre em contato com o nosso suporte{" "}
          <a href="tel:+551140030267" style={{ color: "#4181F8" }}>
            <br/>(11) 4003-0267
          </a>{" "}
          ou{" "}
          <a href="mailto:governanca@ultragaz.com.br" style={{ color: "#4181F8" }}>
            governanca@ultragaz.com.br
          </a>
          .
        </p>
      </div>
      <SignInButton
        type="submit"
        className="mt-3"
        disabled={false}
        onClick={() => {
          window.location.pathname = "/acessar";
          dispatch({ type: "STEP", step: 1 });
        }}
      >
        <span>Acessar</span>
      </SignInButton>
    </ConfirmationContainer>
  );
}

export default Uac;
